import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {getBlocs} from './serve/open'

// 引入公共样式
import '@/styles/index.less'

// 模拟假数据
// import './mock'
import '@/utils/antDesign'
// import 'ant-design-vue/dist/antd.css'

Vue.config.productionTip = false

getBlocs().then(e=>{
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})
